/** Inicio del día local (medianoche) para comparar rachas por calendario. */
function startOfLocalDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

/** Días de calendario enteros entre `a` y `b` (a más reciente que b → positivo). */
function calendarDaysApart(a: Date, b: Date): number {
  const ms = startOfLocalDay(a).getTime() - startOfLocalDay(b).getTime();
  return Math.round(ms / (24 * 60 * 60 * 1000));
}

/**
 * Actualiza racha y marca última práctica al tocar el gimnasio.
 * - Misma fecha local: mantiene la racha (mínimo 1 si ya practicaban).
 * - Día siguiente consecutivo: +1.
 * - Salto de 2+ días: racha vuelve a 1.
 */
export function applyPracticeStreak(
  streakDays: number,
  lastPracticeDate: string | null,
  now = new Date(),
): { streakDays: number; lastPracticeDate: string } {
  const nowIso = now.toISOString();
  if (!lastPracticeDate) {
    return { streakDays: Math.max(1, streakDays || 1), lastPracticeDate: nowIso };
  }
  const last = new Date(lastPracticeDate);
  const diff = calendarDaysApart(now, last);
  if (diff === 0) {
    const s = streakDays > 0 ? streakDays : 1;
    return { streakDays: s, lastPracticeDate: nowIso };
  }
  if (diff === 1) {
    const base = streakDays > 0 ? streakDays : 1;
    return { streakDays: base + 1, lastPracticeDate: nowIso };
  }
  return { streakDays: 1, lastPracticeDate: nowIso };
}

export function formatPracticeDuration(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  return rem > 0 ? `${h}h ${rem}m` : `${h}h`;
}
